import React from 'react'
import { makeStyles } from '@material-ui/core'
import { COLORS } from 'src/utils/Themes/colors'
import { ReactComponent as ListItemIcon } from 'src/assets/RiskReport_images/listItem.svg'

const KeySuggestions = ({ title, data = [] }) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.titleContainer}>
        <h2 className={classes.title}>{title}</h2>
      </div>
      {data?.length ? (
        <div className={classes.lists}>
          {data?.map((li) => (
            <div
              key={`list-${li}`}
              className={classes.listItem}
              id='suggestionItem'
            >
              <div className={classes.icon}>{<ListItemIcon />}</div>
              <div className={classes.label}>{li}</div>
            </div>
          ))}
        </div>
      ) : (
        <div className={classes.noDataText}>No Suggestions Available</div>
      )}
    </div>
  )
}

export default KeySuggestions

const useStyles = makeStyles({
  lists: {
    // marginTop: "20px",
    padding: '0px 24px',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px',
  },
  title: {
    fontSize: '18px',
    lineHeight: '22px',
    padding: '0px 24px',
    textAlign: 'left',
    color: COLORS.GREY,
    marginBottom: '5px',
    fontWeight: '600',
  },
  listItem: {
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'left',
    alignItems: 'flex-start',
    padding: '16px 16px 16px 5px',
    marginBottom: '2px',
    borderBottom: '0.7px solid #D7D7D7',
    '&:last-child': {
      borderBottom: '0px',
    },
  },
  icon: {
    width: '30px',
    textAlign: 'center',
    flexShrink: 0,
    marginRight: '4px',
    '& svg': {
      maxWidth: '100%',
    },
    '& img': {
      maxWidth: '100%',
    },
  },
  label: {
    color: COLORS.GREY,
    fontSize: '13px',
    lineHeight: '16px',
  },
  noDataText: {
    textAlign: 'center',
    fontWeight: 'bold',
    opacity: '0.3',
    marginBottom: '10px',
  },
})
